import { Divider, Grid, Skeleton } from "@mui/material"

export const SkeletonVelesDashView = () => {
  return <>
    <Skeleton animation="pulse" width={150} height={75} />
    <Divider style={{ margin: '16px 0', borderBottomWidth: '2px', borderBottomColor: 'rgba(0,0,0,0.5)' }} />
    <Grid container spacing={3}>
      <Grid item xs={3}>
        <Skeleton animation="pulse" height={300} />
      </Grid>
      <Grid item xs={3}>
        <Skeleton animation="pulse" height={300} />
      </Grid>
      <Grid item xs={3}>
        <Skeleton animation="pulse" height={300} />
      </Grid>
      <Grid item xs={3}>
        <Skeleton animation="pulse" height={300} />
      </Grid>
    </Grid>
  </>
}